import React from "react";
import cn from "classnames";
import Slider from "react-slick";
import {Link} from "react-router-dom";
import styles from "./Popular.module.sass";
import Icon from "../../../components/Icon";
import config from '../../../config'

const SlickArrow = ({currentSlide, slideCount, children, ...props}) => (
    <button {...props}>{children}</button>
);

const Popular = ({items, users}) => {
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: (
            <SlickArrow>
                <Icon name="arrow-next" size="14"/>
            </SlickArrow>
        ),
        prevArrow: (
            <SlickArrow>
                <Icon name="arrow-prev" size="14"/>
            </SlickArrow>
        ),
        responsive: [
            {
                breakpoint: 1340,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                },
            },
        ],
    };

    return (
        <div className={cn("section-bg", styles.section)}>
            <div className={cn("container", styles.container)}>
                <div className={styles.top}>
                    <div className={styles.box}>
                        <div className={styles.stage}>Top bidders</div>
                    </div>
                </div>
                <div className={styles.wrapper}>
                    <Slider className="popular-slider" {...settings}>
                        {items.map((x, index) => (
                            <div className={styles.slide} key={index}>
                                <div className={styles.item}>
                                    <Link className={styles.button} to={'/profile/' + x.owner}>
                                        <div className={styles.body}>
                                            <div className={styles.avatar}>
                                                <img src={users[x.owner].avatar} alt="Avatar"/>
                                            </div>
                                            <div className={styles.name}>{users[x.owner].username}</div>
                                            <div
                                                className={styles.price}>{x.total_amount }&nbsp;{config.symbolName}</div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default Popular;
